module.exports = __webpack_public_path__ + "img/logo3.5653e7ec.jpg";